__turbopack_context__.v({
  "Root": "qxtHeW_Root",
  "Root--Blue": "qxtHeW_Root--Blue",
  "Root--Green": "qxtHeW_Root--Green",
  "Root--Pink": "qxtHeW_Root--Pink",
  "Root--Thin": "qxtHeW_Root--Thin",
  "Root--Yellow": "qxtHeW_Root--Yellow",
  "StatusColor": "qxtHeW_StatusColor",
  "StatusText": "qxtHeW_StatusText",
  "skeleton-loading": "qxtHeW_skeleton-loading",
});
